// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PlayIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.05 14.311 11.04 3.294a2 2 0 0 0-2.767.688c-.178.304-.272.65-.273 1.002v22.032A1.993 1.993 0 0 0 10 29c.369 0 .73-.102 1.045-.294L29.05 17.69a1.977 1.977 0 0 0 0-3.375v-.003ZM10 26.992V5l17.979 11L10 26.992Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
